import { proposal } from 'src/app/models/proposal-model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from 'src/app/components/dialogs/modal-reset-password/modal.component';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { AlertBarService } from 'src/app/services/alert-bar/alert-bar.service';
import { ApiService } from 'src/app/services/api/api.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { FieldValidators } from 'src/app/Validators/field-validators';
import { UUID } from 'angular2-uuid';
import { ModelModalLocaleComponent } from 'src/app/components/dialogs/model-modal-locale/model-modal-locale.component';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { LocalStorageService } from 'angular-web-storage';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginFormGroup!: FormGroup;
  loginObject: any = [];
  userLogin: any = [];

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    public api: ApiService,
    private route: Router,
    private loader: LoadingService,
    private storage: LocalStorageService,
    public gf: GlobalService,
    public toast: AlertBarService,
    private gtmService: GoogleTagManagerService
  ) {
    this.loader.stopLoading();
  }

  showPassword = false;
  showPasswordConfirm = false;

  ngOnInit(): void {
    const loginByVoucher = localStorage.getItem('loginByVoucher');
    if (loginByVoucher) {
      this.loader.startLoading();
    }

    const UltimoAcesso = localStorage.getItem('LAST_ACCESS');
    this.loginFormGroup = this.fb.group({
      Usuario: [
        UltimoAcesso ? JSON.parse(UltimoAcesso).Usuario : '',
        Validators.compose([
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          FieldValidators.cpf,
        ]),
      ],
      Senha: [
        UltimoAcesso ? JSON.parse(UltimoAcesso).Senha : '',
        Validators.required,
      ],
    });

    if (loginByVoucher) {
      const userData = this.storage.get('userData');
      this.loginFormGroup.setValue({
        Usuario: userData.CPF,
        Senha: userData.voucher,
      });
      localStorage.removeItem('loginByVoucher');
      this.login();
    }
  }

  async login() {
    if (this.loginFormGroup.status == 'VALID') {
      this.loader.startLoading();

      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          if (!position) {
            this.loader.stopLoading();
            this.openModalLocale();
          }

          this.loginObject = {
            location: {
              accuracy: position.coords.accuracy,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
            device: {
              cordova: 'unknown',
              model: 'unknown',
              platform: 'Android',
              uuid: UUID.UUID(),
              version: environment.version,
              manufacturer: 'unknown',
              isVirtual: false,
              serial: 'unknown',
            },
            playerId: '',
          };

          this.gtmService.push({
            event: 'login',
          });

          this.api
            .query(
              'auth/login',
              {
                requisicao: Object.assign(
                  this.loginFormGroup.value,
                  this.loginObject
                ),
              },
              'post'
            )
            ?.subscribe(
              async (data: any) => {
                if (data.Sucesso) {
                  const LembrarAcesso = !!document.getElementById(
                    'LembrarAcesso-input'
                  );
                  if (LembrarAcesso)
                    localStorage.setItem(
                      'LAST_ACCESS',
                      JSON.stringify(this.loginFormGroup.value)
                    );

                  this.storage.set('Token', data.Token);
                  this.userLogin = data;

                  this.api
                    .query(
                      'auto-contratacao/cliente/cpf?cpf=' +
                        this.userLogin.CPF +
                        '&token=' +
                        this.userLogin.Token +
                        '',
                      {},
                      'get'
                    )
                    ?.subscribe((dataCliente: any) => {
                      if (dataCliente.Sucesso) {
                        this.storage.set('userData', dataCliente.Retorno);

                        this.api
                          .query(
                            'auto-contratacao/termos/aceite/' +
                              data.CPF +
                              '/?token=' +
                              data.Token +
                              '',
                            {},
                            'get'
                          )
                          ?.subscribe((aceite: any) => {
                            if (aceite?.Retorno?.Aceitou) {
                              this.storage.set('TemPermissaoAcesso', true);

                              this.api
                                .query(
                                  'proposta',
                                  {
                                    requisicao: {
                                      CPF: data.CPF,
                                      Token: data.Token,
                                    },
                                  },
                                  'post'
                                )
                                ?.subscribe((data: any) => {
                                  this.storage.set(
                                    'proposta',
                                    data?.PropostasPendentesDocumento
                                  );
                                  console.log('proposta---------');

                                  if (
                                    data.PropostasPendentesDocumento.length > 0
                                  ) {
                                    const hasPendingProposals =
                                      !!data.PropostasPendentesDocumento.find(
                                        (x: { CodigoSituacao: number }) =>
                                          x.CodigoSituacao !== 0
                                      );
                                    if (hasPendingProposals) {
                                      this.route.navigate([
                                        '/contratos/meus-contratos',
                                      ]);
                                    } else {
                                      this.route.navigate(['/contratos']);
                                    }
                                  } else {
                                    this.route.navigate(['/contratos']);
                                  }
                                });
                            } else {
                              this.route.navigate(['/cadastro/lgpd']);

                              this.gf.toTop();
                              this.loader.stopLoading();
                            }
                          });
                      }
                    });
                } else {
                  this.loader.stopLoading();
                  this.toast.openAlert(data.Mensagem, 'error');
                  this.gf.toTop();
                }
              },
              (e) => {
                this.toast.openAlert(
                  'Houve um erro ao processar a requisição!',
                  'error'
                );
                this.loader.stopLoading();
              }
            );
        },
        (e) => {
          this.loader.stopLoading();
          this.openModalLocale();
        }
      );
    } else {
    }
  }

  openDialogPassword() {
    this.dialog.open(ModalComponent, {
      data: {
        cpf: this.loginFormGroup.get('Usuario')?.value,
      },
    });
  }

  openModalLocale() {
    this.dialog.open(ModelModalLocaleComponent, {
      data: {
        title: 'Não será possível prosseguir',
        text: 'Para continuar, você precisa liberar o acesso à sua localização nas configurações do navegador. Clique no botão abaixo para acessar o tutorial. Caso ainda tenha dificuldades, entre em contato com nossos atendentes.',
      },
    });
  }

  clickCadastro() {
    this.gtmService.push({
      event: 'click_create_account',
    });
    this.route.navigate(['/cadastro']);
  }

  clickLogin() {
    this.gtmService.push({
      event: 'click_login',
    });
    this.route.navigate(['/login']);
  }

  focusOnFieldValidation(current: string, next: string) {
    if (this.loginFormGroup.controls[current].valid) {
      const el = document
        .querySelectorAll(`input[formcontrolname="${next}"]`)
        .item(0);
      (el as HTMLElement)?.focus();
    }
  }
}
